<template>
  <v-data-table
    :headers="headers"
    :items="results"
    :pagination.sync="pagination"
    :rows-per-page-items="[10]"
    :total-items="pagination.totalItems"
    item-key="randomId"
  >
    <template slot="items" slot-scope="props">
      <td>{{ props.item.yearMonth }}</td>
      <td>{{ props.item.buName }}</td>
      <td>{{ documentTypeDisplay(props.item.documentType) }}</td>
      <td>{{ props.item.currencyKey }}</td>
      <td
        style="text-align:right;"
        v-if="props.item.currencyKey === 'JPY'"
      >{{ props.item.taxed |currency({fractionCount:0}) }}</td>
      <td
        style="text-align:right;"
        v-if="props.item.currencyKey === 'JPY'"
      >{{ props.item.untaxed |currency({fractionCount:0})}}</td>
      <td
        style="text-align:right;"
        v-if="props.item.currencyKey === 'JPY'"
      >{{ props.item.tax |currency({fractionCount:0}) }}</td>
      <td
        style="text-align:right;"
        v-if="props.item.currencyKey === 'JPY'"
      >{{ props.item.total |currency({fractionCount:0})}}</td>
      <td
        style="text-align:right;"
        v-if="props.item.currencyKey !== 'JPY'"
      >{{ props.item.taxed |currency({fractionCount:2}) }}</td>
      <td
        style="text-align:right;"
        v-if="props.item.currencyKey !== 'JPY'"
      >{{ props.item.untaxed |currency({fractionCount:2})}}</td>
      <td
        style="text-align:right;"
        v-if="props.item.currencyKey !== 'JPY'"
      >{{ props.item.tax |currency({fractionCount:2}) }}</td>
      <td
        style="text-align:right;"
        v-if="props.item.currencyKey !== 'JPY'"
      >{{ props.item.total |currency({fractionCount:2})}}</td>
      <td>
        <v-btn @click="showDetail(props.item.id)" v-if="props.item.source=='system'">明细</v-btn>
        <span v-if="props.item.source=='manual_finance'">(手动入力)</span>
      </td>
    </template>
  </v-data-table>
</template>
<script>
export default {
  props: ['query'],
  data() {
    return {
      headers: [
        { text: '年月', sortable: false },
        { text: '事業本部', sortable: false },
        { text: '金額タイプ', sortable: false },
        { text: '通貨', sortable: false },
        { text: '課税金額', sortable: false, align: 'right' },
        { text: '非課税金額', sortable: false, align: 'right' },
        { text: '税金', sortable: false, align: 'right' },
        { text: '税込金額', sortable: false, align: 'right' },
        { text: '', sortable: false }
      ],
      results: [],
      pagination: {
        rowsPerPage: 10
      }
    }
  },
  methods: {
    documentTypeDisplay(documentType) {
      if (documentType === 'ZX') return 'ZX-当月'
      if (documentType === 'ZX_history') return 'ZX-繰越'
      return documentType
    },
    params() {
      return {
        params: {
          ...this.query,
          ...this.$pageable()
        }
      }
    },
    showDetail(shipmentId) {
      this.$emit('detail', shipmentId)
    },
    load() {
      this.$http.get(`/arap/finance/get-ar`, this.params()).then(res => {
        this.results = res.data.content
        this.pagination.page = res.data.number + 1
        this.pagination.rowsPerPage = res.data.size
        this.pagination.totalItems = res.data.totalElements
      })
    },
    search() {
      this.pagination.page = 0
      this.load()
    }
  },
  watch: {
    pagination() {
      this.load()
    }
  }
}
</script>